var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.21257 2.22755C1.21257 2.22755 1.21213 2.22858 1.21213 2.23062V12.1233C1.21213 12.1254 1.21257 12.1264 1.21257 12.1264L1.21458 12.1292L1.21739 12.1312C1.21739 12.1312 1.21839 12.1317 1.22048 12.1317H12.1545C12.1566 12.1317 12.1576 12.1312 12.1576 12.1312L12.1604 12.1292L12.1617 12.1277L12.1624 12.1264C12.1624 12.1264 12.1629 12.1254 12.1629 12.1233V2.23062C12.1629 2.22858 12.1624 2.22755 12.1624 2.22755L12.1604 2.22472L12.1576 2.22272C12.1576 2.22272 12.1566 2.22227 12.1545 2.22227H1.22048C1.21844 2.22227 1.21741 2.22271 1.21741 2.22271L1.21458 2.22472L1.21257 2.22755ZM0.1875 2.23062C0.1875 1.66012 0.649983 1.19764 1.22048 1.19764H12.1545C12.725 1.19764 13.1875 1.66012 13.1875 2.23062V12.1233C13.1875 12.6938 12.725 13.1563 12.1545 13.1563H1.22048C0.649983 13.1563 0.1875 12.6938 0.1875 12.1233V2.23062Z",
    fill: "#008731"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66626 0.15625V3.78422H3.64163V0.15625H4.66626Z",
    fill: "#008731"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73337 0.15625V3.78422H8.70874V0.15625H9.73337Z",
    fill: "#008731"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.21213 5H12.1629V6H1.21213V5Z",
    fill: "#008731"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1be82961.svg";
export { ForwardRef as ReactComponent };